import {
  eDmNhomLoaiThuChiActionIds,
  IDmNhomLoaiThuChiActionTypes,
} from "./../../action-types/category/IDmNhomLoaiThuChiActions";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { nhomLoaiThuChiApi } from "../../../api/category/nhomLoaiThuChiApi";
import { IDmNhomLoaiThuChi } from "../../../model/respone/category/IDmNhomLoaiThuChi";

export function* nhomLoaiThuChiSaga(): any {
  yield takeLatest(eDmNhomLoaiThuChiActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmNhomLoaiThuChiActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmNhomLoaiThuChiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(nhomLoaiThuChiApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.nhomLoaiThuChi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.nhomLoaiThuChi.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
function* saveWorker(action: IDmNhomLoaiThuChiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDmNhomLoaiThuChi;
  if (payload.id > 0) {
    res = yield call(nhomLoaiThuChiApi.Update, payload);
  } else {
    res = yield call(nhomLoaiThuChiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.nhomLoaiThuChi.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.nhomLoaiThuChi.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IDmNhomLoaiThuChiActionTypes): any {
  const res: IBaseRespone = yield call(
    nhomLoaiThuChiApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.nhomLoaiThuChi.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.nhomLoaiThuChi.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
